<template lang="pug">
filter-detail-container(
  :title="$t('filter_gender')"
  @back="back"
  @save="save"
)
  template(v-slot:body)
    .pa-6
      .mb-4 {{ $t('filter_customer_with_gender') }}:
      yc-select.mt-2(v-model="currentGender" :label="$t('choose_gender')" :items="options")
</template>

<script>
import FilterDetailContainer from './FilterDetailContainer.vue'

export default {
  props: ['filter'],
  components: { FilterDetailContainer },
  data: () => ({
    currentGender: '',
    options: [
      { id: 'male', label: 'Male' },
      { id: 'female', label: 'Female' }
    ],
  }),
  created() {
    this.currentGender = this.filter.gender
  },
  methods: {
    save() {
      const filter = {
        gender: this.currentGender,
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>